//productMedia = array of product images from fusion or shopify
export const updateMediaGrid = (productMedia, productData) => {
    // Loading media grid elements
    const imageElements = document.querySelectorAll('.fusion-pdp__media-item');

    // wrapper of the entire media grid
    const mediaContainer = document.getElementById('fusionMediaInnerWrapper');

    productMedia.forEach((img, i) => {
        // console.log(mediaContainer)
        if (typeof imageElements[i] == 'undefined' || typeof imageElements[i].innerHTML == undefined || imageElements[i].innerHTML == 'undefined') {
            // add media elements and containers
            mediaContainer.insertAdjacentHTML('beforeend', `<div id="fusionMediaItem"><div class="fusion-pdp__media-item media pdp-media-ratio"><img class="lazyload" loading="lazy" height="1400" width="1050" data-src="${img.src}" src="${img.src}"></div></div>`)
        } else {
            // change the image media - change the element
            imageElements[i].innerHTML =
                `
            ${i === 0 && productData.product.model_info != null ? `
            <div class="pdp__model-info"><span>${productData.product.model_info}</span></div>` : ``}
            <img class="lazyload" loading="lazy" height="1400" width="1050" data-src="${img.src}" src="${img.src}">
            `
        }
    })

    // remove the extra elements left over between differnt product media counts
    imageElements.forEach((elm, i) => {
        if (i > productMedia.length - 1) {
            if(elm.closest) {
                elm.closest('#fusionMediaItem').remove(); // Remove parent
            }
        }
    })

    if (window.innerWidth <= 900 && window.fusionDataLayer.activeSlider) {
        window.fusionElements.pdpMobileSlider.update()
    }
}
